import {Component, Input} from '@angular/core';

/**
 * Generated class for the SocialIconsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'social-icons',
    templateUrl: 'social-icons.html'
})
export class SocialIconsComponent {

    @Input() facebook: string;
    @Input() instagram: string;
    @Input() twitter: string;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/components/social-icons/social-icons.ts